import { useCustomPagination } from 'hooks/useCustomPagination';
import React from 'react';
import { CustomButton } from '..';

const Pagination = ({ count = 2, totalPages, currentPage, handlePage }) => {
  const { obtenerNumeros } = useCustomPagination();

  // Obtener números de páginas a la izquierda y derecha
  const leftNumbers = obtenerNumeros('anteriores', currentPage, count, totalPages);
  const rightNumbers = obtenerNumeros('siguientes', currentPage, count, totalPages);

  return (
    <div className="pagination-container">
      {currentPage > 1 && (
        <CustomButton
          type="secondary"
          onClick={() => handlePage(currentPage - 1)}
          className="button-pagination"
        >
          {'<'}
        </CustomButton>
      )}
        
      {leftNumbers.length > 0 && Math.min(...leftNumbers) > 1 && (
        <>
          <CustomButton
            type="secondary"
            onClick={() => handlePage(1)}
            className="button-pagination"
          >
            {1}
          </CustomButton>
          {Math.min(...leftNumbers) > 2 && (
            <p className="more-info-points">...</p>
          )}
        </>
      )}

      {leftNumbers.map((number) => (
        <CustomButton
          key={number}
          type="secondary"
          className="button-pagination"
          onClick={() => handlePage(number)}
        >
          {number}
        </CustomButton>
      ))}

      <CustomButton className="button-pagination active">
        {currentPage}
      </CustomButton>

      {rightNumbers.map((number) => (
        <CustomButton
          key={number}
          type="secondary"
          className="button-pagination"
          onClick={() => handlePage(number)}
        >
          {number}
        </CustomButton>
      ))}

      {rightNumbers.length > 0 && totalPages > Math.max(...rightNumbers) + 1 && (
        <p className="more-info-points">...</p>
      )}

      {rightNumbers.length > 0 && totalPages !== Math.max(...rightNumbers) && (
        <CustomButton
          type="secondary"
          className="button-pagination"
          onClick={() => handlePage(totalPages)}
        >
          {totalPages}
        </CustomButton>
      )}

      {currentPage < totalPages && (
        <CustomButton
          type="secondary"
          className="button-pagination"
          onClick={() => handlePage(currentPage + 1)}
        >
          {'>'}
        </CustomButton>
      )}
    </div>
  );
};

export default Pagination;
